import React from 'react';

interface SkeletonLoaderProps {
  type?: 'card' | 'text' | 'circle';
  width?: string;
  height?: string;
  count?: number;
}

const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({ 
  type = 'card', 
  width = '100%', 
  height = '100px',
  count = 1 
}) => {
  const renderSkeleton = () => {
    switch (type) {
      case 'card':
        return (
          <div
            style={{
              width,
              height,
              background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
              backgroundSize: '200% 100%',
              borderRadius: '12px',
              animation: 'skeleton-loading 1.5s ease-in-out infinite',
              marginBottom: '12px',
            }}
          />
        );
      case 'text':
        return (
          <div
            style={{
              width,
              height: height || '16px',
              background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
              backgroundSize: '200% 100%',
              borderRadius: '4px',
              animation: 'skeleton-loading 1.5s ease-in-out infinite',
              marginBottom: '8px',
            }}
          />
        );
      case 'circle':
        return (
          <div
            style={{
              width,
              height: width,
              background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
              backgroundSize: '200% 100%',
              borderRadius: '50%',
              animation: 'skeleton-loading 1.5s ease-in-out infinite',
            }}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      <style>{`
        @keyframes skeleton-loading {
          0% {
            background-position: 200% 0;
          }
          100% {
            background-position: -200% 0;
          }
        }
      `}</style>
      {Array.from({ length: count }).map((_, index) => (
        <React.Fragment key={index}>{renderSkeleton()}</React.Fragment>
      ))}
    </>
  );
};

export default SkeletonLoader;

